import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import {
  totalVendor,
  totalVoucherIssued,
  totalVoucherRedeem,
  viewOffer,
} from "../../Redux/Slice/Offer";
import { useDispatch, useSelector } from "react-redux";

const HomeCard = () => {
  // const card = [
  //   {
  //     id: 1,
  //     color: "rgb(236, 64, 122)",
  //     name: "Budding Talent Count",
  //     link: "/buddingview",
  //     userType: "BuddingTalent",
  //   },
  //   {
  //     id: 2,
  //     color: "rgb(73, 163, 241)",
  //     name: "Influencer",
  //     link: "/influencerview",
  //     userType: "Influencer",
  //   },
  //   {
  //     id: 3,
  //     color: "rgb(102, 187, 106)",
  //     name: "Scout",
  //     link: "/scoutview",
  //     userType: "Scout",
  //   },
  // ];
  const dispatch = useDispatch();
  const { ViewOffersData, totalVoucherRedeemData, totalVoucherIssuedData,totalVendorData } =
    useSelector((state) => state.app);
  const [user, setuser] = useState("");
  const [typeOfcompany, settypeOfcompany] = useState("");
  const [toalServices, settoalServices] = useState("");
  const [toalNonMember, setToalNonMember] = useState("");
  const [toalNonMemberRequest, setToalNonMemberRequest] = useState("");
  const [UpgradedTotalNonMember, setUpgradedTotalNonMember] = useState("");

  const item = [
    "rgb(236, 64, 122)",
    "rgb(73, 163, 241)",
    "rgb(102, 187, 106)",
    "#F3660B",
    "#E56B6B",
    "#F56CA4",
  ];
  const navigate = useNavigate();

  // get user / compant / service data
  const getCategoryData = async () => {
    const res = await HttpClient.requestData("user", "GET", {});
    const res1 = await HttpClient.requestData("view-companyType", "GET", {});
    const res2 = await HttpClient.requestData("view-service", "GET", {});
    if (res && res?.status) {
      setuser(res?.data.length);
    } else {
      toast(res?.message);
    }
    if (res1 && res1?.status) {
      settypeOfcompany(res1?.data.length);
    } else {
      toast(res?.message);
    }
    if (res2 && res2?.status) {
      settoalServices(res2?.data.length);
    } else {
      toast(res?.message);
    }
  };

  //Nonmember Length
  const NonMemberLength = async () => {
    const res = await HttpClient.requestData("non-member-user", "GET", {});
    if (res && res?.status) {
      setToalNonMember(res?.data?.length);
    } else {
      toast(res?.message);
    }
  };
  
  const NonMemberUpgradeRequestLength = async () => {
    const res = await HttpClient.requestData(
      "view-upgradation-request-byAdmin",
      "GET",
      {}
    );

    if (res && res?.status) {
      setToalNonMemberRequest(
        res?.data
          ?.filter((item) => !item.isUpgrade)
          ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
          ?.length
      );
    } else {
      toast(res?.message);
    }
  };

  const NonMemberUpgradedLength = async () => {
    const res = await HttpClient.requestData(
      "view-upgradation-request-byAdmin",
      "GET",
      {}
    );

    if (res && res?.status) {
      setUpgradedTotalNonMember(
        res?.data
          ?.filter((item) => item.isUpgrade)
          ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
          ?.length
      );
    } else {
      toast(res?.message);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, [user, typeOfcompany, toalServices]);
  useEffect(() => {
    NonMemberLength();
  }, [toalNonMember]);
  useEffect(() => {
    NonMemberUpgradeRequestLength();
  }, [toalNonMemberRequest]);
  useEffect(() => {
    NonMemberUpgradedLength();
  }, [UpgradedTotalNonMember]);
  useEffect(() => {
    dispatch(viewOffer());
    dispatch(totalVoucherIssued());
    dispatch(totalVoucherRedeem());
    dispatch(totalVendor());
  }, []);

  return (
    <>
      <div className="HomeTop">
        <div className="row">
          {/* ....MEMBER.... */}
          <div className="col-md-4 col-12">
            <div className="HomeCard">
              <h5 className="HomeCardHead">Total Users :</h5>
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[0],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {user}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[0],
                  }}
                  onClick={() => navigate("/view-user-data")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
                  View More
                </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[0] }}>
                <i className="fa-regular fa-user"></i>
              </div>
            </div>
          </div>
          {/* ....COMPANIES.... */}
          <div className="col-md-4 col-12">
            <div className="HomeCard">
              <h5 className="HomeCardHead">Total Type of Companies :</h5>
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[1],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {typeOfcompany}
                </span>{" "}
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[1],
                  }}
                  onClick={() => navigate("/type-of-company")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
                  View More
                </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[1] }}>
                <i className="fa-regular fa-building"></i>
              </div>
            </div>
          </div>
          {/* ....SERVICES.... */}
          <div className="col-md-4 col-12">
            <div className="HomeCard">
              <h5 className="HomeCardHead">Total Services : </h5>
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[2],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {toalServices}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[2],
                  }}
                  onClick={() => navigate("/type-of-services")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
                  View More
                </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[2] }}>
                <i className="fa-solid fa-briefcase"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          {/* ....NON MEMBERS.... */}
          <div className="col-md-4 col-12 ">
            <div className="HomeCard">
              <h5 className="HomeCardHead mt-1">Total Non Members : </h5>
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[3],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {toalNonMember}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[3],
                  }}
                  onClick={() => navigate("/non-member")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
                  View More
                </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[3] }}>
                <i className="fa-solid fa-user-lock"></i>
              </div>
            </div>
          </div>
          {/* ....NON MEMBERS UPGRADE REQUEST.... */}
          <div className="col-md-4 col-12 ">
            <div className="HomeCard">
              <h5 className="HomeCardHead mt-1">
                Total Non Members Upgrade Request :
              </h5>
              {/* <h5 className="HomeCardHead">'''' </h5> */}
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[4],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {toalNonMemberRequest}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[4],
                  }}
                  onClick={() => navigate("/non-member-upgrade-request-home")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
                  View More
                </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[4] }}>
                <i className="fa-regular fa-bell"></i>
              </div>
            </div>
          </div>
          {/* ....NON MEMBERS UPGRADED.... */}
          <div className="col-md-4 col-12 ">
            <div className="HomeCard">
              <h5 className="HomeCardHead mt-1 ">
                Total Non Member Updated :{" "}
              </h5>
              {/* <h5 className="HomeCardHead"></h5> */}
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[5],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {UpgradedTotalNonMember}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[5],
                  }}
                  onClick={() => navigate("/upgraded-non-member-home")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
          View More
        </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[5] }}>
                <i className="fa-solid fa-user-plus"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          {/* ....TOTAL VENDORS.... */}
          <div className="col-md-4 col-12 ">
            <div className="HomeCard">
              <h5 className="HomeCardHead mt-1 ">Total Vendors : </h5>
              {/* <h5 className="HomeCardHead"></h5> */}
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[3],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {totalVendorData}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[3],
                  }}
                  onClick={() => navigate("/manage-offers")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
          View More
        </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[3] }}>
                <i className="fa-solid fa-user-plus"></i>
              </div>
            </div>
          </div>

          {/* ....TOTAL VOUCHER ISSUE.... */}
          <div className="col-md-4 col-12 ">
            <div className="HomeCard">
              <h5 className="HomeCardHead mt-1 ">Total Voucher Issued : </h5>
              {/* <h5 className="HomeCardHead"></h5> */}
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[1],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {totalVoucherIssuedData ? totalVoucherIssuedData : 0}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[1],
                  }}
                  onClick={() => navigate("/manage-offers")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
          View More
        </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[1] }}>
                <i className="fa-solid fa-user-plus"></i>
              </div>
            </div>
          </div>

          {/* ....TOTAL VOUCHER REDEEMED.... */}
          <div className="col-md-4 col-12 ">
            <div className="HomeCard">
              <h5 className="HomeCardHead mt-1 ">Total Vouchers Reedemed : </h5>
              {/* <h5 className="HomeCardHead"></h5> */}
              <p className="HomeCardPara">
                <span
                  style={{
                    color: item[4],
                    fontSize: "30px",
                    paddingLeft: "6px",
                  }}
                >
                  {totalVoucherRedeemData}
                </span>
              </p>
              <hr />

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  className="HomeCardViewbtn"
                  style={{
                    background: item[4],
                  }}
                  onClick={() => navigate("/manage-offers")}
                >
                  View
                </button>
              </div>
              {/* <Link to={item.link}  className="homecardLink">
          View More
        </Link> */}
              <div className="cardIconDiv" style={{ backgroundColor: item[4] }}>
                <i className="fa-solid fa-user-plus"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeCard;
